import { ExpensesPage } from "./expenses"
import { ExpensesPageOffline } from "./expenses-offline"

/**
 * Wrapper component to toggle between offline and online expense implementations
 * The new offline repository is now the default.
 * To use the old implementation: localStorage.setItem('useLegacyExpenses', 'true')
 */
export function ExpensesPageWrapper() {
  // Check if we should use the legacy version (opt-in to old behavior)
  const useLegacy = localStorage.getItem('useLegacyExpenses') === 'true';

  if (useLegacy) {
    return <ExpensesPage />;
  }

  // Default to the new offline-first repository
  return <ExpensesPageOffline />;
}